import { Document, Suggestion } from "../../../types/document";
import { BlockReferences } from "./BlockReferences";
import PanelLayout from "./PanelLayout";

interface ContentPanelProps {
  highlightFirst?: boolean;
  isOpen: boolean;
  document: Document | null;
  suggestion?: Suggestion | null;
  placeholder?: string;
  primaryBlockId?: string;
}

export const BlockReferencesPanel = ({
  isOpen,
  document,
  suggestion,
  highlightFirst,
  placeholder,
}: ContentPanelProps) => {
  if (!isOpen || !document) return null;

  const description = suggestion
    ? "View all referenced blocks"
    : "No references available for this block.";

  return (
    <PanelLayout description={description}>
      <BlockReferences
        document={document}
        suggestion={suggestion}
        highlightFirst={highlightFirst}
        placeholder={placeholder}
      />
    </PanelLayout>
  );
};
